<div class="parent full-height relative">
    <div class="message flex flex-col absolute-center">
        <h1 class="header">ACCESS DENIED</h1>
        <hr>
        <p>You do not have access to this page!</p>
    </div>
</div>
